// extracted by mini-css-extract-plugin
module.exports = {"small":"_3FI_J","countdown":"_3mmUY","large":"_1w83l","countdownNumber":"DjdQP"};